import AutoSizer from "react-virtualized-auto-sizer";
import {FixedSizeList} from "react-window";
import React from "react";

import './List.css'

export type ListProps = {
    createElement: (c: any) => JSX.Element,
    collection: any[],
    elementHeight: number, // 70
    id: string
}

function ListEntry({style, element} : {style: any, element : JSX.Element}) {
    const styleCopy = Object.assign({}, style)
    delete styleCopy.width;
    styleCopy.marginLeft = "0";

    return <div className="list-item" style={styleCopy}>{element}</div>
}

export function List(props : ListProps) {
    const elementOfIndex = ({ index, style } : any) => {
        const element = <>{props.createElement(props.collection[index])}</>
        return <ListEntry style={style} element={element}/>
    }
    
    return <div id={props.id} className="list">
        <AutoSizer>
            {({height, width} : {height : number, width : number}) => (
                <FixedSizeList
                    height={height}
                    itemCount={props.collection.length}
                    itemSize={props.elementHeight}
                    width={width}
                    style={{overflowX: "hidden"}}>
                    {elementOfIndex}
                </FixedSizeList>)
            }
        </AutoSizer>
    </div>
}

export const ListMemo = React.memo(List);